// src/config.js

/**const config = {
  API_URL: "http://127.0.0.1:8000",
  WEB_URL: "http://localhost/p/public_html/public",
  APP_URL: "http://127.0.0.1:3000",
  BASE_COLOR:'#e65c00',
  FONT_FAMILY:'Quicksand',
};

**/
const config = {
  API_URL: "https://sefams.emagetechnologiesltd.com/shule/public",
  APP_URL: "https://sefams.emagetechnologiesltd.com",
   WEB_URL: "https://sefams.emagetechnologiesltd.com/lms/public",
  BASE_COLOR:'#e65c00',
  FONT_FAMILY:'Quicksand',
};

/**
 * 
const config = {
  API_URL: "https://admins.junisaproducts.com",
  APP_URL: "https://admins.junisaproducts.com/admin/payroll_",
   WEB_URL: "http://127.0.0.1:8000",
  BASE_COLOR:'#e65c00',
  FONT_FAMILY:'Quicksand',
};

**/
/**const config = {
  API_URL: "https://finance.insigniah2o.co.ke/cms/public",
   WEB_URL: "http://127.0.0.1:8000",
  APP_URL: "https://finance.insigniah2o.co.ke",
  BASE_COLOR:'#e65c00',
  FONT_FAMILY:'Quicksand',
};
**/
/**
const config = {
  API_URL: "https://finance.joharischool.co.ke/shule/public",
   WEB_URL: "http://127.0.0.1:8000",
  APP_URL: "https://finance.joharischool.co.ke",
  BASE_COLOR:'#e65c00',
  FONT_FAMILY:'Quicksand',
};
const config = {
  API_URL: "https://cms.junisaproducts.com/cms/public",
   WEB_URL: "http://127.0.0.1:8000",
  BASE_COLOR:'#e65c00',
  APP_URL: "https://cms.junisaproducts.com",
  FONT_FAMILY:'Quicksand',
};



const config = {
  API_URL: "https://junisaproducts.com/cms/public",
   WEB_URL: "http://127.0.0.1:8000",
  BASE_COLOR:'#e65c00',
  APP_URL: "https://junisaproducts.com",
  FONT_FAMILY:'Quicksand',
};**/
/**
const config = {
  API_URL: "https://salesapp.infinitivelogic.com",
   WEB_URL: "http://127.0.0.1:8000",
  APP_URL: "https://salesapp.infinitivelogic.com/salesapp",
  BASE_COLOR:'#e65c00',
  FONT_FAMILY:'Quicksand',
};


**/



export default config;
